import { z } from 'zod'
import { asEnumType } from '@gqloom/zod'

// GraphQL name is deliberately NOT 'PlanTier': shared/schemas/support-assistant/
// support-chat.schemas.ts already registers that name for a different enum
// (standard|pro|enterprise). Two enums sharing a GraphQL type name with different
// values break federation composition once both reach a subgraph — and OC-320
// exposes this one via the sites resolver.
export const planTierSchema = z
  .enum(['basic', 'premium', 'pro'])
  .register(asEnumType, { name: 'ProductPlanTier' })

export type PlanTier = z.infer<typeof planTierSchema>
